import { useCallback } from 'react';

import isNil from 'lodash/isNil';

import { LocalStorageKey } from '@nocowanie/core/enums';

import { SearchCriteriaKeys } from '@app/enums';
import * as accommodationHelpers from '@app/helpers/accommodation.helpers';
import { QueryAccommodationArgs } from '@app/models/api/api-types';

import { useCrossStorage } from './useCrossStorage';

export function useSaveFiltersToCrossStorage() {
    const crossStorageClient = useCrossStorage();

    const saveFiltersToCrossStorage = useCallback(
        async (
            params: Partial<QueryAccommodationArgs> & {
                instantReservation?: boolean;
                flexDates?: number;
            },
        ) => {
            if (!crossStorageClient) {
                return;
            }

            if (isNil(params?.instantReservation)) {
                // Keep `instantReservation` from LS unless overridden by manual user action
                const queryString = await crossStorageClient.getItem(
                    LocalStorageKey.SearchCriteria,
                );

                const urlParams = new URLSearchParams(queryString);
                const instantReservation = urlParams.get(SearchCriteriaKeys.OnlineReservation);

                params.instantReservation = instantReservation === '1';
            }

            const mappedParams = accommodationHelpers.generateLegacySearchCriteriaParams(params);

            crossStorageClient
                .setItem(LocalStorageKey.SearchCriteria, mappedParams)
                .catch(error => {
                    console.warn(error);
                });
        },
        [crossStorageClient],
    );

    return saveFiltersToCrossStorage;
}
